/**
 * Une édition unitaire d'une cellule : changement d'index de couleur.
 * Stocke `oldIdx` et `newIdx` pour permettre revert (undo).
 */
export type CellEdit = {
  row: number;
  col: number;
  oldIdx: number;
  newIdx: number;
};

/**
 * Un stroke = série d'éditions issues d'un même drag utilisateur.
 * Une seule entrée d'historique = un stroke. Undo défait tout le stroke.
 */
export type Stroke = ReadonlyArray<CellEdit>;

/**
 * Historique linéaire. `past` = strokes déjà appliqués (undoables),
 * `future` = strokes annulés (redoables).
 */
export type History = {
  past: ReadonlyArray<Stroke>;
  future: ReadonlyArray<Stroke>;
};

export const EMPTY_HISTORY: History = { past: [], future: [] };
